// Tracks which conversation the member is looking at so foreground
// message pushes can stay silent for that thread (iMessage-style).

let activeThreadId: number | null = null;

export function setActiveChatThreadId(threadId: number | null): void {
  activeThreadId = threadId;
}

export function getActiveChatThreadId(): number | null {
  return activeThreadId;
}

export function threadIdFromPushData(data: unknown): number | null {
  if (!data || typeof data !== 'object') return null;
  const record = data as Record<string, unknown>;
  const raw = record.thread_id ?? record.threadId;
  if (raw != null && raw !== '') {
    const parsed = Number(raw);
    if (Number.isFinite(parsed)) return parsed;
  }
  const url = record.url;
  if (typeof url !== 'string' || !url) return null;
  try {
    const fromQuery = new URL(url, 'https://ironforums.org').searchParams.get('thread');
    if (fromQuery) {
      const parsed = Number(fromQuery);
      if (Number.isFinite(parsed)) return parsed;
    }
  } catch {
    const match = url.match(/[?&]thread=(\d+)/);
    if (match) return Number(match[1]);
  }
  return null;
}

export function shouldSuppressForegroundMessagePush(data: unknown): boolean {
  const threadId = threadIdFromPushData(data);
  return threadId != null && threadId === activeThreadId;
}
